import PropTypes from "prop-types"

import withFilters from "areas/collection/hoc/with-filters"
import Switch from "components/ui/switch"

const InternalHolidayDeliveryToggle = ({ filter, setFilter }) => {
  const { categories, unique: isUnique } = filter

  if (!categories || categories.length < 1) return null

  return categories.map((category, index) => (
    <div
      className="tablet:pb-10 tablet:pt-10 pb-8 pt-4"
      key={`${category.name}${index}`}
    >
      <Switch
        checked={category.is_active_filter}
        containerClassName="w-full flex-row-reverse justify-between"
        disabled={category.disabled}
        id={category.filter_param[0]}
        onChange={() =>
          setFilter(category.filter_param, isUnique, category.belongs_to)
        }
        toggleClassName="bg-black peer-checked:bg-green-darker"
      >
        <p className="text-green-darker text-16 tablet:text-14 leading-18 tablet:leading-16 tracking-tigher font-bold">
          {category.name}
        </p>
      </Switch>
    </div>
  ))
}

InternalHolidayDeliveryToggle.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
}

const HolidayDeliveryToggle = withFilters(InternalHolidayDeliveryToggle)

export default HolidayDeliveryToggle
